//module TrackMan.Configuration {

import { Parameter } from './Parameters';
import { Direction } from './Directions';
import { Unit, UnitSystem } from './Units';

// interfaces
export interface IUnitConfiguration {
  [parameter: number]: UnitConfiguration;
}

export interface IUnitSystemConfiguration {
  [unitSystem: number]: IUnitConfiguration;
}

// Classes
export class UnitConfiguration {
  //private vars
  parameter: Parameter;
  unit: Unit;
  displayUnit: string;
  title: string;
  format: string;
  direction: Direction;

  // Constructor
  constructor(
    public param: Parameter,
    public u: Unit,
    public du: string,
    public t: string,
    public f: string,
    public d: Direction
  ) {
    this.parameter = param;
    this.unit = u;
    this.displayUnit = du;
    this.title = t;
    this.format = f;
    this.direction = d;
  }

  // Instance member
  getParameter() {
    return this.parameter;
  }
  getUnit() {
    return this.unit;
  }
  getDisplayUnit() {
    return this.displayUnit;
  }
  getTitle() {
    return this.title;
  }
  getFormat() {
    return this.format;
  }
}

export const UnitSystemConfiguration: IUnitSystemConfiguration = {};
//Define European Parameters
const EuropeanConfiguration: IUnitConfiguration = {};
//Club parameters

EuropeanConfiguration[Parameter.ClubSpeed] = new UnitConfiguration(
  Parameter.ClubSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Club Speed',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.AttackAngle] = new UnitConfiguration(
  Parameter.AttackAngle,
  Unit.Degree,
  'Deg',
  'Attack Ang.',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.ClubPath] = new UnitConfiguration(
  Parameter.ClubPath,
  Unit.Degree,
  'Deg',
  'Club Path',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.DynamicLoft] = new UnitConfiguration(
  Parameter.DynamicLoft,
  Unit.Degree,
  'Deg',
  'Dyn. Loft',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.FaceAngle] = new UnitConfiguration(
  Parameter.FaceAngle,
  Unit.Degree,
  'Deg',
  'Face Ang.',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.SpinLoft] = new UnitConfiguration(
  Parameter.SpinLoft,
  Unit.Degree,
  'Deg',
  'Spin Loft',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.FaceToPath] = new UnitConfiguration(
  Parameter.FaceToPath,
  Unit.Degree,
  'Deg',
  'Face To Path',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.SwingPlane] = new UnitConfiguration(
  Parameter.SwingPlane,
  Unit.Degree,
  'Deg',
  'Swing Pl.',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.SwingDirection] = new UnitConfiguration(
  Parameter.SwingDirection,
  Unit.Degree,
  'Deg',
  'Swing Dir.',
  '%.1f',
  Direction.None
);
//Launch parameters
EuropeanConfiguration[Parameter.BallSpeed] = new UnitConfiguration(
  Parameter.BallSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Ball Speed',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.SmashFactor] = new UnitConfiguration(
  Parameter.SmashFactor,
  Unit.UnitLess,
  '',
  'Smash Fac.',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.LaunchAngle] = new UnitConfiguration(
  Parameter.LaunchAngle,
  Unit.Degree,
  'Deg',
  'Launch Ang.',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.LaunchDirection] = new UnitConfiguration(
  Parameter.LaunchDirection,
  Unit.Degree,
  'Deg',
  'Launch Dir.',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.SpinRate] = new UnitConfiguration(
  Parameter.SpinRate,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.SpinAxis] = new UnitConfiguration(
  Parameter.SpinAxis,
  Unit.Degree,
  'Deg',
  'Spin Axis',
  '%.1f',
  Direction.None
);
//Flight parameters
EuropeanConfiguration[Parameter.Height] = new UnitConfiguration(
  Parameter.Height,
  Unit.Meter,
  'm',
  'Height',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.Carry] = new UnitConfiguration(
  Parameter.Carry,
  Unit.Meter,
  'm',
  'Carry',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.Total] = new UnitConfiguration(
  Parameter.Total,
  Unit.Meter,
  'm',
  'Total',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.Side] = new UnitConfiguration(
  Parameter.Side,
  Unit.Meter,
  'm',
  'Side',
  '%.1f',
  Direction.LeftRight
);
EuropeanConfiguration[Parameter.SideTotal] = new UnitConfiguration(
  Parameter.SideTotal,
  Unit.Meter,
  'm',
  'Side Tot.',
  '%.1f',
  Direction.LeftRight
);
EuropeanConfiguration[Parameter.LandingAngle] = new UnitConfiguration(
  Parameter.LandingAngle,
  Unit.Degree,
  'Deg',
  'Land. Ang.',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.DistanceToPin] = new UnitConfiguration(
  Parameter.DistanceToPin,
  Unit.Meter,
  'm',
  'From Pin',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.DistanceToTarget] = new UnitConfiguration(
  Parameter.DistanceToTarget,
  Unit.Meter,
  'm',
  'Target',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.LengthToTarget] = new UnitConfiguration(
  Parameter.LengthToTarget,
  Unit.Meter,
  'm',
  'Target',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.HangTime] = new UnitConfiguration(
  Parameter.HangTime,
  Unit.Second,
  's',
  'Hang Time',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.LastData] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Meter,
  'm',
  'Last Data',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.Score] = new UnitConfiguration(
  Parameter.Score,
  Unit.UnitLess,
  '',
  'Score',
  '%.1f',
  Direction.None
); //TODO change to format "0.#"
EuropeanConfiguration[Parameter.LowPointDistance] = new UnitConfiguration(
  Parameter.LowPointDistance,
  Unit.Centimeter,
  'cm',
  'Low Point',
  '%.1f',
  Direction.BeforeAfter
);

//Skid and roll parameters
//EuropeanConfiguration[Parameter.DistanceScore] = new UnitConfiguration(Parameter.DistanceScore, Unit.UnitLess, "", "DIST. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
//EuropeanConfiguration[Parameter.DirectionScore] = new UnitConfiguration(Parameter.DirectionScore, Unit.UnitLess, "", "DIR. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
EuropeanConfiguration[Parameter.EffectiveStimp] = new UnitConfiguration(
  Parameter.EffectiveStimp,
  Unit.Foot,
  'Ft',
  'Eff. Stimp',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.SpeedDrop] = new UnitConfiguration(
  Parameter.SpeedDrop,
  Unit.Percentage,
  '%',
  'Speed Drop',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.RollPercentage] = new UnitConfiguration(
  Parameter.RollPercentage,
  Unit.Percentage,
  '%',
  'Roll %',
  '%.0f',
  Direction.None
);
//EuropeanConfiguration[Parameter.RollDeceleration] = new UnitConfiguration(Parameter.RollDeceleration, Unit.MeterPerSecondSquared, "m/s²", "ROLL DEC.", "%.2f", Direction.None);
EuropeanConfiguration[Parameter.RollSpeed] = new UnitConfiguration(
  Parameter.RollSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Roll Speed',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.SkidDistance] = new UnitConfiguration(
  Parameter.SkidDistance,
  Unit.Meter,
  'm',
  'Skid Dist.',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.TotalBreak] = new UnitConfiguration(
  Parameter.TotalBreak,
  Unit.Centimeter,
  'cm',
  'Total Break',
  '%.0f',
  Direction.LeftRight
);

//Extra units form the Trackman Data Units project
EuropeanConfiguration[Parameter.Dispersion] = new UnitConfiguration(
  Parameter.Dispersion,
  Unit.Meter,
  'm',
  'Dispersion',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.Temperature] = new UnitConfiguration(
  Parameter.Temperature,
  Unit.Celsius,
  '°C',
  'Temperature',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.Altitude] = new UnitConfiguration(
  Parameter.Altitude,
  Unit.Meter,
  'm',
  'Altitude',
  '%.0f',
  Direction.None
);

// Base initialization - Extra units from the TPS Units.cs project - Check if this is needed - it has the same title as height and if BeforeAfter is the same as DownUp in the other file
//EuropeanConfiguration[Parameter.TargetHeight] = new UnitConfiguration(Parameter.TargetHeight, Unit.Meter, "m", "HEIGHT", "%.1f", Direction.BeforeAfter);//Direction.DownUp
//EuropeanConfiguration[Parameter.TargetDistance] = new UnitConfiguration(Parameter.TargetDistance, Unit.Meter, "m", "DISTANCE", "%.1f", Direction.None);
//EuropeanConfiguration[Parameter.TargetSide] = new UnitConfiguration(Parameter.TargetSide, Unit.Meter, "m", "SIDE", "%.1f", Direction.LeftRight);
//EuropeanConfiguration[Parameter.TeeHeight] = new UnitConfiguration(Parameter.TeeHeight, Unit.Meter, "m", "HEIGHT", "%.2f", Direction.BeforeAfter);//Direction.DownUp
//EuropeanConfiguration[Parameter.TeeDistance] = new UnitConfiguration(Parameter.TeeDistance, Unit.Meter, "m", "DISTANCE", "%.2f", Direction.None);

//Override standard values for putting
//EuropeanConfiguration[Parameter.BallSpeed] = new UnitConfiguration(Parameter.BallSpeed, Unit.MilesPerHour, "mph", "BALL SPEED", "%.1f", Direction.None);
//EuropeanConfiguration[Parameter.LastData] = new UnitConfiguration(Parameter.LastData, Unit.Meter, "m", "TRACK DIST.", "%.1f", Direction.None);
//EuropeanConfiguration[Parameter.Total] = new UnitConfiguration(Parameter.Total, Unit.Meter, "m", "DISTANCE", "%.2f", Direction.None);
//EuropeanConfiguration[Parameter.SideTotal] = new UnitConfiguration(Parameter.SideTotal, Unit.Centimeter, "cm", "SIDE", "%.0f", Direction.None);

//Impact location
EuropeanConfiguration[Parameter.ImpactHeight] = new UnitConfiguration(
  Parameter.ImpactHeight,
  Unit.Millimeter,
  'mm',
  'Imp. Height',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.ImpactOffset] = new UnitConfiguration(
  Parameter.ImpactOffset,
  Unit.Millimeter,
  'mm',
  'Imp. Offset',
  '%.0f',
  Direction.None
);

//Additional parameters added to the TPS
EuropeanConfiguration[Parameter.BackswingTime] = new UnitConfiguration(
  Parameter.BackswingTime,
  Unit.Second,
  's',
  'Backswing',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.ForwardswingTime] = new UnitConfiguration(
  Parameter.ForwardswingTime,
  Unit.Second,
  's',
  'Forw. Swing',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.Tempo] = new UnitConfiguration(
  Parameter.Tempo,
  Unit.Empty,
  '',
  'Tempo',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.DynamicLie] = new UnitConfiguration(
  Parameter.DynamicLie,
  Unit.Degree,
  'Deg',
  'Dyn. Lie',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.StrokeLength] = new UnitConfiguration(
  Parameter.StrokeLength,
  Unit.Centimeter,
  'cm',
  'Stroke Len.',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.Curve] = new UnitConfiguration(
  Parameter.Curve,
  Unit.Meter,
  'm',
  'Curve',
  '%.1f',
  Direction.None
);

//Replacements for putting reports
EuropeanConfiguration[Parameter.Distance] = new UnitConfiguration(
  Parameter.Total,
  Unit.Meter,
  'm',
  'Distance',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.TrackedDistance] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Meter,
  'm',
  'Track Dist',
  '%.2f',
  Direction.None
);
EuropeanConfiguration[Parameter.SideDistance] = new UnitConfiguration(
  Parameter.Side,
  Unit.Centimeter,
  'cm',
  'Side',
  '%.0f',
  Direction.LeftRight
);
//Add European UnitSystem
UnitSystemConfiguration[UnitSystem.European] = EuropeanConfiguration;

//Define Metric Parameters
const MetricConfiguration: IUnitConfiguration = {};
//Club parameters

MetricConfiguration[Parameter.ClubSpeed] = new UnitConfiguration(
  Parameter.ClubSpeed,
  Unit.MeterPerSecond,
  'm/s',
  'Club Speed',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.AttackAngle] = new UnitConfiguration(
  Parameter.AttackAngle,
  Unit.Degree,
  'Deg',
  'Attack Ang.',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.ClubPath] = new UnitConfiguration(
  Parameter.ClubPath,
  Unit.Degree,
  'Deg',
  'Club Path',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.DynamicLoft] = new UnitConfiguration(
  Parameter.DynamicLoft,
  Unit.Degree,
  'Deg',
  'Dyn. Loft',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.FaceAngle] = new UnitConfiguration(
  Parameter.FaceAngle,
  Unit.Degree,
  'Deg',
  'Face Ang.',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.SpinLoft] = new UnitConfiguration(
  Parameter.SpinLoft,
  Unit.Degree,
  'Deg',
  'Spin Loft',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.FaceToPath] = new UnitConfiguration(
  Parameter.FaceToPath,
  Unit.Degree,
  'Deg',
  'Face To Path',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.SwingPlane] = new UnitConfiguration(
  Parameter.SwingPlane,
  Unit.Degree,
  'Deg',
  'Swing Pl.',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.SwingDirection] = new UnitConfiguration(
  Parameter.SwingDirection,
  Unit.Degree,
  'Deg',
  'Swing Dir.',
  '%.1f',
  Direction.None
);
//Launch parameters
MetricConfiguration[Parameter.BallSpeed] = new UnitConfiguration(
  Parameter.BallSpeed,
  Unit.MeterPerSecond,
  'm/s',
  'Ball Speed',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.SmashFactor] = new UnitConfiguration(
  Parameter.SmashFactor,
  Unit.UnitLess,
  '',
  'Smash Fac.',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.LaunchAngle] = new UnitConfiguration(
  Parameter.LaunchAngle,
  Unit.Degree,
  'Deg',
  'Launch Ang.',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.LaunchDirection] = new UnitConfiguration(
  Parameter.LaunchDirection,
  Unit.Degree,
  'Deg',
  'Launch Dir.',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.SpinRate] = new UnitConfiguration(
  Parameter.SpinRate,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.SpinAxis] = new UnitConfiguration(
  Parameter.SpinAxis,
  Unit.Degree,
  'Deg',
  'Spin Axis',
  '%.1f',
  Direction.None
);
//Flight parameters
MetricConfiguration[Parameter.Height] = new UnitConfiguration(
  Parameter.Height,
  Unit.Meter,
  'm',
  'Height',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.Carry] = new UnitConfiguration(
  Parameter.Carry,
  Unit.Meter,
  'm',
  'Carry',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.Total] = new UnitConfiguration(
  Parameter.Total,
  Unit.Meter,
  'm',
  'Total',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.Side] = new UnitConfiguration(
  Parameter.Side,
  Unit.Meter,
  'm',
  'Side',
  '%.1f',
  Direction.LeftRight
);
MetricConfiguration[Parameter.SideTotal] = new UnitConfiguration(
  Parameter.SideTotal,
  Unit.Meter,
  'm',
  'Side Tot.',
  '%.1f',
  Direction.LeftRight
);
MetricConfiguration[Parameter.LandingAngle] = new UnitConfiguration(
  Parameter.LandingAngle,
  Unit.Degree,
  'Deg',
  'Land. Ang.',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.DistanceToPin] = new UnitConfiguration(
  Parameter.DistanceToPin,
  Unit.Meter,
  'm',
  'From Pin',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.DistanceToTarget] = new UnitConfiguration(
  Parameter.DistanceToTarget,
  Unit.Meter,
  'm',
  'Target',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.LengthToTarget] = new UnitConfiguration(
  Parameter.LengthToTarget,
  Unit.Meter,
  'm',
  'Target',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.HangTime] = new UnitConfiguration(
  Parameter.HangTime,
  Unit.Second,
  's',
  'Hang Time',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.LastData] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Meter,
  'm',
  'Last Data',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.Score] = new UnitConfiguration(
  Parameter.Score,
  Unit.UnitLess,
  '',
  'Score',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.LowPointDistance] = new UnitConfiguration(
  Parameter.LowPointDistance,
  Unit.Centimeter,
  'cm',
  'Low Point',
  '%.1f',
  Direction.BeforeAfter
);

//Skid and roll parameters
//MetricConfiguration[Parameter.DistanceScore] = new UnitConfiguration(Parameter.DistanceScore, Unit.UnitLess, "", "DIST. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
//MetricConfiguration[Parameter.DirectionScore] = new UnitConfiguration(Parameter.DirectionScore, Unit.UnitLess, "", "DIR. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
MetricConfiguration[Parameter.EffectiveStimp] = new UnitConfiguration(
  Parameter.EffectiveStimp,
  Unit.Foot,
  'Ft',
  'Eff. Stimp',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.SpeedDrop] = new UnitConfiguration(
  Parameter.SpeedDrop,
  Unit.Percentage,
  '%',
  'Speed Drop',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.RollPercentage] = new UnitConfiguration(
  Parameter.RollPercentage,
  Unit.Percentage,
  '%',
  'Roll %',
  '%.0f',
  Direction.None
);
//MetricConfiguration[Parameter.RollDeceleration] = new UnitConfiguration(Parameter.RollDeceleration, Unit.MeterPerSecondSquared, "m/s²", "ROLL DEC.", "%.2f", Direction.None);
MetricConfiguration[Parameter.RollSpeed] = new UnitConfiguration(
  Parameter.RollSpeed,
  Unit.MeterPerSecond,
  'm/s',
  'Roll Speed',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.SkidDistance] = new UnitConfiguration(
  Parameter.SkidDistance,
  Unit.Meter,
  'm',
  'Skid Dist.',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.TotalBreak] = new UnitConfiguration(
  Parameter.TotalBreak,
  Unit.Centimeter,
  'cm',
  'Total Break',
  '%.0f',
  Direction.LeftRight
);

//Extra units form the Trackman Data Units project
MetricConfiguration[Parameter.Dispersion] = new UnitConfiguration(
  Parameter.Dispersion,
  Unit.Meter,
  'm',
  'Dispersion',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.Temperature] = new UnitConfiguration(
  Parameter.Temperature,
  Unit.Celsius,
  '°C',
  'Temperature',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.Altitude] = new UnitConfiguration(
  Parameter.Altitude,
  Unit.Meter,
  'm',
  'Altitude',
  '%.0f',
  Direction.LeftRight
);

// Base initialization - Extra units from the TPS Units.cs project - Check if this is needed - it has the same title as height and if BeforeAfter is the same as DownUp in the other file
//MetricConfiguration[Parameter.TargetHeight] = new UnitConfiguration(Parameter.TargetHeight, Unit.Meter, "m", "HEIGHT", "%.1f", Direction.BeforeAfter);//Direction.DownUp
//MetricConfiguration[Parameter.TargetDistance] = new UnitConfiguration(Parameter.TargetDistance, Unit.Meter, "m", "DISTANCE", "%.1f", Direction.None);
//MetricConfiguration[Parameter.TargetSide] = new UnitConfiguration(Parameter.TargetSide, Unit.Meter, "m", "SIDE", "%.1f", Direction.LeftRight);
//MetricConfiguration[Parameter.TeeHeight] = new UnitConfiguration(Parameter.TeeHeight, Unit.Meter, "m", "HEIGHT", "%.2f", Direction.BeforeAfter);//Direction.DownUp
//MetricConfiguration[Parameter.TeeDistance] = new UnitConfiguration(Parameter.TeeDistance, Unit.Meter, "m", "DISTANCE", "%.2f", Direction.None);

//Override standard values for putting
//MetricConfiguration[Parameter.BallSpeed] = new UnitConfiguration(Parameter.BallSpeed, Unit.MeterPerSecond, "mps", "BALL SPEED", "%.1f", Direction.None);
//MetricConfiguration[Parameter.LastData] = new UnitConfiguration(Parameter.LastData, Unit.Meter, "m", "TRACK DIST.", "%.1f", Direction.None);
//MetricConfiguration[Parameter.Total] = new UnitConfiguration(Parameter.Total, Unit.Meter, "m", "DISTANCE", "%.2f", Direction.None);
//MetricConfiguration[Parameter.SideTotal] = new UnitConfiguration(Parameter.SideTotal, Unit.Centimeter, "cm", "SIDE", "%.0f", Direction.None);

//Impact location
MetricConfiguration[Parameter.ImpactHeight] = new UnitConfiguration(
  Parameter.ImpactHeight,
  Unit.Millimeter,
  'mm',
  'Imp. Height',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.ImpactOffset] = new UnitConfiguration(
  Parameter.ImpactOffset,
  Unit.Millimeter,
  'mm',
  'Imp. Offset',
  '%.0f',
  Direction.None
);

//Additional parameters added to the TPS
MetricConfiguration[Parameter.BackswingTime] = new UnitConfiguration(
  Parameter.BackswingTime,
  Unit.Second,
  's',
  'Backswing',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.ForwardswingTime] = new UnitConfiguration(
  Parameter.ForwardswingTime,
  Unit.Second,
  's',
  'Forw. Swing',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.Tempo] = new UnitConfiguration(
  Parameter.Tempo,
  Unit.Empty,
  '',
  'Tempo',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.DynamicLie] = new UnitConfiguration(
  Parameter.DynamicLie,
  Unit.Degree,
  'Deg',
  'Dyn. Lie',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.StrokeLength] = new UnitConfiguration(
  Parameter.StrokeLength,
  Unit.Centimeter,
  'cm',
  'Stroke Len.',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.Curve] = new UnitConfiguration(
  Parameter.Curve,
  Unit.Meter,
  'm',
  'Curve',
  '%.1f',
  Direction.LeftRight
);

//Replacements for putting reports
MetricConfiguration[Parameter.Distance] = new UnitConfiguration(
  Parameter.Total,
  Unit.Meter,
  'm',
  'Distance',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.TrackedDistance] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Meter,
  'm',
  'Track Dist',
  '%.2f',
  Direction.None
);
MetricConfiguration[Parameter.SideDistance] = new UnitConfiguration(
  Parameter.Side,
  Unit.Centimeter,
  'cm',
  'Side',
  '%.0f',
  Direction.LeftRight
);
//Add Metric UnitSystem
UnitSystemConfiguration[UnitSystem.Metric] = MetricConfiguration;

//Define Us Parameters
const UsConfiguration: IUnitConfiguration = {};
//Club parameters
UsConfiguration[Parameter.ClubSpeed] = new UnitConfiguration(
  Parameter.ClubSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Club Speed',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.AttackAngle] = new UnitConfiguration(
  Parameter.AttackAngle,
  Unit.Degree,
  'Deg',
  'Attack Ang.',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.ClubPath] = new UnitConfiguration(
  Parameter.ClubPath,
  Unit.Degree,
  'Deg',
  'Club Path',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.DynamicLoft] = new UnitConfiguration(
  Parameter.DynamicLoft,
  Unit.Degree,
  'Deg',
  'Dyn. Loft',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.FaceAngle] = new UnitConfiguration(
  Parameter.FaceAngle,
  Unit.Degree,
  'Deg',
  'Face Ang.',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SpinLoft] = new UnitConfiguration(
  Parameter.SpinLoft,
  Unit.Degree,
  'Deg',
  'Spin Loft',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.FaceToPath] = new UnitConfiguration(
  Parameter.FaceToPath,
  Unit.Degree,
  'Deg',
  'Face To Path',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SwingPlane] = new UnitConfiguration(
  Parameter.SwingPlane,
  Unit.Degree,
  'Deg',
  'Swing Pl.',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SwingDirection] = new UnitConfiguration(
  Parameter.SwingDirection,
  Unit.Degree,
  'Deg',
  'Swing Dir.',
  '%.1f',
  Direction.None
);
//Launch paramet
UsConfiguration[Parameter.BallSpeed] = new UnitConfiguration(
  Parameter.BallSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Ball Speed',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SmashFactor] = new UnitConfiguration(
  Parameter.SmashFactor,
  Unit.UnitLess,
  '',
  'Smash Fac.',
  '%.2f',
  Direction.None
);
UsConfiguration[Parameter.LaunchAngle] = new UnitConfiguration(
  Parameter.LaunchAngle,
  Unit.Degree,
  'Deg',
  'Launch Ang.',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.LaunchDirection] = new UnitConfiguration(
  Parameter.LaunchDirection,
  Unit.Degree,
  'Deg',
  'Launch Dir.',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SpinRate] = new UnitConfiguration(
  Parameter.SpinRate,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.SpinAxis] = new UnitConfiguration(
  Parameter.SpinAxis,
  Unit.Degree,
  'Deg',
  'Spin Axis',
  '%.1f',
  Direction.None
);
//Flight paramet
UsConfiguration[Parameter.Height] = new UnitConfiguration(
  Parameter.Height,
  Unit.Foot,
  'Ft',
  'Height',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.Carry] = new UnitConfiguration(
  Parameter.Carry,
  Unit.Yard,
  'Yds',
  'Carry',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.Total] = new UnitConfiguration(
  Parameter.Total,
  Unit.Yard,
  'Yds',
  'Total',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.Side] = new UnitConfiguration(
  Parameter.Side,
  Unit.Foot,
  'Ft',
  'Side',
  '%.1f',
  Direction.LeftRight
); //TODO Foot/Inch format
UsConfiguration[Parameter.SideTotal] = new UnitConfiguration(
  Parameter.SideTotal,
  Unit.Foot,
  'Ft',
  'Side Tot.',
  '%.1f',
  Direction.LeftRight
); //TODO Foot/Inch format
UsConfiguration[Parameter.LandingAngle] = new UnitConfiguration(
  Parameter.LandingAngle,
  Unit.Degree,
  'Deg',
  'Land. Ang.',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.DistanceToPin] = new UnitConfiguration(
  Parameter.DistanceToPin,
  Unit.Foot,
  'Ft',
  'From Pin',
  '%.1f',
  Direction.None
); //TODO Foot/Inch format
UsConfiguration[Parameter.DistanceToTarget] = new UnitConfiguration(
  Parameter.DistanceToTarget,
  Unit.Yard,
  'Yds',
  'Target',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.LengthToTarget] = new UnitConfiguration(
  Parameter.LengthToTarget,
  Unit.Yard,
  'Yds',
  'Target',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.HangTime] = new UnitConfiguration(
  Parameter.HangTime,
  Unit.Second,
  's',
  'Hang Time',
  '%.2f',
  Direction.None
);
UsConfiguration[Parameter.LastData] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Yard,
  'Yds',
  'Last Data',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.Score] = new UnitConfiguration(
  Parameter.Score,
  Unit.UnitLess,
  '',
  'Score',
  '%.1f',
  Direction.None
); //TODO change to format "0.#"
UsConfiguration[Parameter.LowPointDistance] = new UnitConfiguration(
  Parameter.LowPointDistance,
  Unit.Inch,
  'In',
  'Low Point',
  '%.1f',
  Direction.BeforeAfter
);
//Skid and roll parameters
//UsConfiguration[Parameter.DistanceScore] = new UnitConfiguration(Parameter.DistanceScore, Unit.UnitLess, "", "DIST. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
//UsConfiguration[Parameter.DirectionScore] = new UnitConfiguration(Parameter.DirectionScore, Unit.UnitLess, "", "DIR. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
UsConfiguration[Parameter.EffectiveStimp] = new UnitConfiguration(
  Parameter.EffectiveStimp,
  Unit.Foot,
  'Ft',
  'Eff. Stimp',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.SpeedDrop] = new UnitConfiguration(
  Parameter.SpeedDrop,
  Unit.Percentage,
  '%',
  'Speed Drop',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.RollPercentage] = new UnitConfiguration(
  Parameter.RollPercentage,
  Unit.Percentage,
  '%',
  'Roll %',
  '%.0f',
  Direction.None
); // Check the way meter per second squared should be written

/*UsConfiguration[Parameter.RollDeceleration] = new UnitConfiguration(Parameter.RollDeceleration, Unit.FeetPerSecondSquared, "ft/s²", "ROLL DEC.", "%.2f", Direction.None);*/ UsConfiguration[
  Parameter.RollSpeed
] = new UnitConfiguration(
  Parameter.RollSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Roll Speed',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SkidDistance] = new UnitConfiguration(
  Parameter.SkidDistance,
  Unit.Inch,
  'In',
  'Skid Dist.',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.TotalBreak] = new UnitConfiguration(
  Parameter.TotalBreak,
  Unit.Foot,
  'Ft',
  'Total Break',
  '%.0f',
  Direction.LeftRight
); //TODO Foot/Inch format
//Extra units form the Trackman Data Units project
UsConfiguration[Parameter.Dispersion] = new UnitConfiguration(
  Parameter.Dispersion,
  Unit.Foot,
  'Ft',
  'Dispersion',
  '%.1f',
  Direction.None
); //TODO Foot/Inch format
UsConfiguration[Parameter.Temperature] = new UnitConfiguration(
  Parameter.Temperature,
  Unit.Fahrenheit,
  '°F',
  'Temperature',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.Altitude] = new UnitConfiguration(
  Parameter.Altitude,
  Unit.Foot,
  'Ft',
  'Altitude',
  '%.0f',
  Direction.None
);

// Base initialization - Extra units from the TPS Units.cs project - Check if this is needed - it has the same title as height and if BeforeAfter is the same as DownUp in the other file
//UsConfiguration[Parameter.TargetHeight] = new UnitConfiguration(Parameter.TargetHeight, Unit.Foot, "ft", "HEIGHT", "%.0f", Direction.BeforeAfter);//Direction.DownUp
//UsConfiguration[Parameter.TargetDistance] = new UnitConfiguration(Parameter.TargetDistance, Unit.Yard, "yds", "DISTANCE", "%.1f", Direction.None);
//UsConfiguration[Parameter.TargetSide] = new UnitConfiguration(Parameter.TargetSide, Unit.Yard, "yds", "SIDE", "%.1f", Direction.LeftRight);
//UsConfiguration[Parameter.TeeHeight] = new UnitConfiguration(Parameter.TeeHeight, Unit.Inch, "in", "HEIGHT", "%.0f", Direction.BeforeAfter);//Direction.DownUp
//UsConfiguration[Parameter.TeeDistance] = new UnitConfiguration(Parameter.TeeDistance, Unit.Foot, "ft", "DISTANCE", "%.0f", Direction.None);//TODO Foot/Inch format

//Override standard values for putting
//UsConfiguration[Parameter.BallSpeed] = new UnitConfiguration(Parameter.BallSpeed, Unit.MilesPerHour, "mph", "BALL SPEED", "%.1f", Direction.None);
//UsConfiguration[Parameter.LastData] = new UnitConfiguration(Parameter.LastData, Unit.Foot, "ft", "TRACK DIST.", "%.1f", Direction.None);//TODO Foot/Inch format
//UsConfiguration[Parameter.Total] = new UnitConfiguration(Parameter.Total, Unit.Foot, "ft", "DISTANCE", "%.2f", Direction.None);//TODO Foot/Inch format
//UsConfiguration[Parameter.SideTotal] = new UnitConfiguration(Parameter.SideTotal, Unit.Foot, "ft", "SIDE", "%.0f", Direction.None);//TODO Foot/Inch format

//Impact location
UsConfiguration[Parameter.ImpactHeight] = new UnitConfiguration(
  Parameter.ImpactHeight,
  Unit.Millimeter,
  'mm',
  'Imp. Height',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.ImpactOffset] = new UnitConfiguration(
  Parameter.ImpactOffset,
  Unit.Millimeter,
  'mm',
  'Imp. Offset',
  '%.0f',
  Direction.None
);

//Additional parameters added to the TPS
UsConfiguration[Parameter.BackswingTime] = new UnitConfiguration(
  Parameter.BackswingTime,
  Unit.Second,
  's',
  'Backswing',
  '%.2f',
  Direction.None
);
UsConfiguration[Parameter.ForwardswingTime] = new UnitConfiguration(
  Parameter.ForwardswingTime,
  Unit.Second,
  's',
  'Forw. Swing',
  '%.2f',
  Direction.None
);
UsConfiguration[Parameter.Tempo] = new UnitConfiguration(
  Parameter.Tempo,
  Unit.Empty,
  '',
  'Tempo',
  '%.2f',
  Direction.None
);
UsConfiguration[Parameter.DynamicLie] = new UnitConfiguration(
  Parameter.DynamicLie,
  Unit.Degree,
  'Deg',
  'Dyn. Lie',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.StrokeLength] = new UnitConfiguration(
  Parameter.StrokeLength,
  Unit.Inch,
  'In',
  'Stroke Len.',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.Curve] = new UnitConfiguration(
  Parameter.Curve,
  Unit.Foot,
  'Ft',
  'Curve',
  '%.1f',
  Direction.LeftRight
);

//Replacements for putting reports
UsConfiguration[Parameter.Distance] = new UnitConfiguration(
  Parameter.Total,
  Unit.Foot,
  'Ft',
  'Distance',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.TrackedDistance] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Foot,
  'Ft',
  'Track Dist',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SideDistance] = new UnitConfiguration(
  Parameter.Side,
  Unit.Inch,
  'In',
  'Side',
  '%.0f',
  Direction.LeftRight
);

//Add Us UnitSystem
UnitSystemConfiguration[UnitSystem.Us] = UsConfiguration;

//Define Korean Parameters
const KoreanConfiguration: IUnitConfiguration = {};
//Club parameters
KoreanConfiguration[Parameter.ClubSpeed] = new UnitConfiguration(
  Parameter.ClubSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Club Speed',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.AttackAngle] = new UnitConfiguration(
  Parameter.AttackAngle,
  Unit.Degree,
  'Deg',
  'Attack Ang.',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.ClubPath] = new UnitConfiguration(
  Parameter.ClubPath,
  Unit.Degree,
  'Deg',
  'Club Path',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.DynamicLoft] = new UnitConfiguration(
  Parameter.DynamicLoft,
  Unit.Degree,
  'Deg',
  'Dyn. Loft',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.FaceAngle] = new UnitConfiguration(
  Parameter.FaceAngle,
  Unit.Degree,
  'Deg',
  'Face Ang.',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SpinLoft] = new UnitConfiguration(
  Parameter.SpinLoft,
  Unit.Degree,
  'Deg',
  'Spin Loft',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.FaceToPath] = new UnitConfiguration(
  Parameter.FaceToPath,
  Unit.Degree,
  'Deg',
  'Face To Path',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SwingPlane] = new UnitConfiguration(
  Parameter.SwingPlane,
  Unit.Degree,
  'Deg',
  'Swing Pl.',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SwingDirection] = new UnitConfiguration(
  Parameter.SwingDirection,
  Unit.Degree,
  'Deg',
  'Swing Dir.',
  '%.1f',
  Direction.None
);
//Launch parameters
KoreanConfiguration[Parameter.BallSpeed] = new UnitConfiguration(
  Parameter.BallSpeed,
  Unit.MilesPerHour,
  'Mph',
  'Ball Speed',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SmashFactor] = new UnitConfiguration(
  Parameter.SmashFactor,
  Unit.UnitLess,
  '',
  'Smash Fac.',
  '%.2f',
  Direction.None
);
KoreanConfiguration[Parameter.LaunchAngle] = new UnitConfiguration(
  Parameter.LaunchAngle,
  Unit.Degree,
  'Deg',
  'Launch Ang.',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.LaunchDirection] = new UnitConfiguration(
  Parameter.LaunchDirection,
  Unit.Degree,
  'Deg',
  'Launch Dir.',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SpinRate] = new UnitConfiguration(
  Parameter.SpinRate,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.SpinAxis] = new UnitConfiguration(
  Parameter.SpinAxis,
  Unit.Degree,
  'Deg',
  'Spin Axis',
  '%.1f',
  Direction.None
);
//Flight parameters
KoreanConfiguration[Parameter.Height] = new UnitConfiguration(
  Parameter.Height,
  Unit.Yard,
  'Yds',
  'Height',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.Carry] = new UnitConfiguration(
  Parameter.Carry,
  Unit.Yard,
  'Yds',
  'Carry',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.Total] = new UnitConfiguration(
  Parameter.Total,
  Unit.Yard,
  'Yds',
  'Total',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.Side] = new UnitConfiguration(
  Parameter.Side,
  Unit.Yard,
  'Yds',
  'Side',
  '%.1f',
  Direction.LeftRight
);
KoreanConfiguration[Parameter.SideTotal] = new UnitConfiguration(
  Parameter.SideTotal,
  Unit.Yard,
  'Yds',
  'Side Tot.',
  '%.1f',
  Direction.LeftRight
);
KoreanConfiguration[Parameter.LandingAngle] = new UnitConfiguration(
  Parameter.LandingAngle,
  Unit.Degree,
  'Deg',
  'Land. Ang.',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.DistanceToPin] = new UnitConfiguration(
  Parameter.DistanceToPin,
  Unit.Yard,
  'Yds',
  'From Pin',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.DistanceToTarget] = new UnitConfiguration(
  Parameter.DistanceToTarget,
  Unit.Yard,
  'Yds',
  'Target',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.LengthToTarget] = new UnitConfiguration(
  Parameter.LengthToTarget,
  Unit.Yard,
  'Yds',
  'Target',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.HangTime] = new UnitConfiguration(
  Parameter.HangTime,
  Unit.Second,
  's',
  'Hang Time',
  '%.2f',
  Direction.None
);
KoreanConfiguration[Parameter.LastData] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Yard,
  'Yds',
  'Last Data',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.Score] = new UnitConfiguration(
  Parameter.Score,
  Unit.UnitLess,
  '',
  'Score',
  '%.1f',
  Direction.None
); //TODO change to format "0.#"
KoreanConfiguration[Parameter.LowPointDistance] = new UnitConfiguration(
  Parameter.LowPointDistance,
  Unit.Inch,
  'In',
  'Low Point',
  '%.0f',
  Direction.BeforeAfter
);

//Skid and roll parameters
//KoreanConfiguration[Parameter.DistanceScore] = new UnitConfiguration(Parameter.DistanceScore, Unit.UnitLess, "", "DIST. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
//KoreanConfiguration[Parameter.DirectionScore] = new UnitConfiguration(Parameter.DirectionScore, Unit.UnitLess, "", "DIR. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
KoreanConfiguration[Parameter.EffectiveStimp] = new UnitConfiguration(
  Parameter.EffectiveStimp,
  Unit.Foot,
  'Ft',
  'Eff. Stimp',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.SpeedDrop] = new UnitConfiguration(
  Parameter.SpeedDrop,
  Unit.Percentage,
  '%',
  'Speed Drop',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.RollPercentage] = new UnitConfiguration(
  Parameter.RollPercentage,
  Unit.Percentage,
  '%',
  'Roll %',
  '%.0f',
  Direction.None
); // Check the way meter per second squared should be written

/*KoreanConfiguration[Parameter.RollDeceleration] = new UnitConfiguration(Parameter.RollDeceleration, Unit.MeterPerSecondSquared, "m/s²", "ROLL DEC.", "%.2f", Direction.None);*/ KoreanConfiguration[
  Parameter.RollSpeed
] = new UnitConfiguration(
  Parameter.RollSpeed,
  Unit.MeterPerSecond,
  'm/s',
  'Roll Speed',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SkidDistance] = new UnitConfiguration(
  Parameter.SkidDistance,
  Unit.Inch,
  'In',
  'Skid Dist.',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.TotalBreak] = new UnitConfiguration(
  Parameter.TotalBreak,
  Unit.Foot,
  'Ft',
  'Total Break',
  '%.0f',
  Direction.LeftRight
); //TODO Foot/Inch format

//Extra units form the Trackman Data Units project
KoreanConfiguration[Parameter.Dispersion] = new UnitConfiguration(
  Parameter.Dispersion,
  Unit.Yard,
  'Yds',
  'Dispersion',
  '%.1f',
  Direction.None
); //TODO Foot/Inch format
KoreanConfiguration[Parameter.Temperature] = new UnitConfiguration(
  Parameter.Temperature,
  Unit.Celsius,
  '°C',
  'Temperature',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.Altitude] = new UnitConfiguration(
  Parameter.Altitude,
  Unit.Meter,
  'm',
  'Altitude',
  '%.0f',
  Direction.None
);

//// Base initialization - Extra units from the TPS Units.cs project - Check if this is needed - it has the same title as height and if BeforeAfter is the same as DownUp in the other file
//KoreanConfiguration[Parameter.TargetHeight] = new UnitConfiguration(Parameter.TargetHeight, Unit.Foot, "ft", "HEIGHT", "%.0f", Direction.BeforeAfter);//Direction.DownUp
//KoreanConfiguration[Parameter.TargetDistance] = new UnitConfiguration(Parameter.TargetDistance, Unit.Yard, "yds", "DISTANCE", "%.1f", Direction.None);
//KoreanConfiguration[Parameter.TargetSide] = new UnitConfiguration(Parameter.TargetSide, Unit.Yard, "yds", "SIDE", "%.1f", Direction.LeftRight);
//KoreanConfiguration[Parameter.TeeHeight] = new UnitConfiguration(Parameter.TeeHeight, Unit.Inch, "in", "HEIGHT", "%.0f", Direction.BeforeAfter);//Direction.DownUp
//KoreanConfiguration[Parameter.TeeDistance] = new UnitConfiguration(Parameter.TeeDistance, Unit.Foot, "ft", "DISTANCE", "%.0f", Direction.None);//TODO Foot/Inch format

////Override standard values for putting
//KoreanConfiguration[Parameter.BallSpeed] = new UnitConfiguration(Parameter.BallSpeed, Unit.MeterPerSecond, "mps", "BALL SPEED", "%.1f", Direction.None);
//KoreanConfiguration[Parameter.LastData] = new UnitConfiguration(Parameter.LastData, Unit.Foot, "ft", "TRACK DIST.", "%.1f", Direction.None);//TODO Foot/Inch format
//KoreanConfiguration[Parameter.Total] = new UnitConfiguration(Parameter.Total, Unit.Foot, "ft", "DISTANCE", "%.2f", Direction.None);//TODO Foot/Inch format
//KoreanConfiguration[Parameter.SideTotal] = new UnitConfiguration(Parameter.SideTotal, Unit.Foot, "ft", "SIDE", "%.0f", Direction.None);//TODO Foot/Inch format

//Impact location
KoreanConfiguration[Parameter.ImpactHeight] = new UnitConfiguration(
  Parameter.ImpactHeight,
  Unit.Millimeter,
  'mm',
  'Imp. Height',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.ImpactOffset] = new UnitConfiguration(
  Parameter.ImpactOffset,
  Unit.Millimeter,
  'mm',
  'Imp. Offset',
  '%.0f',
  Direction.None
);

//Additional parameters added to the TPS
KoreanConfiguration[Parameter.BackswingTime] = new UnitConfiguration(
  Parameter.BackswingTime,
  Unit.Second,
  's',
  'Backswing',
  '%.2f',
  Direction.None
);
KoreanConfiguration[Parameter.ForwardswingTime] = new UnitConfiguration(
  Parameter.ForwardswingTime,
  Unit.Second,
  's',
  'Forw. Swing',
  '%.2f',
  Direction.None
);
KoreanConfiguration[Parameter.Tempo] = new UnitConfiguration(
  Parameter.Tempo,
  Unit.Empty,
  '',
  'Tempo',
  '%.2f',
  Direction.None
);
KoreanConfiguration[Parameter.DynamicLie] = new UnitConfiguration(
  Parameter.DynamicLie,
  Unit.Degree,
  'Deg',
  'Dyn. Lie',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.StrokeLength] = new UnitConfiguration(
  Parameter.StrokeLength,
  Unit.Inch,
  'In',
  'Stroke Len.',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.Curve] = new UnitConfiguration(
  Parameter.Curve,
  Unit.Yard,
  'Yds',
  'Curve',
  '%.1f',
  Direction.LeftRight
);

//Replacements for putting reports
KoreanConfiguration[Parameter.Distance] = new UnitConfiguration(
  Parameter.Total,
  Unit.Yard,
  'Yds',
  'Distance',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.TrackedDistance] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Yard,
  'Yds',
  'Track Dist',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SideDistance] = new UnitConfiguration(
  Parameter.Side,
  Unit.Inch,
  'In',
  'Side',
  '%.0f',
  Direction.LeftRight
);
//Add Us UnitSystem
UnitSystemConfiguration[UnitSystem.Korean] = KoreanConfiguration;

//Define Us Parameters
const JapaneseConfiguration: IUnitConfiguration = {};
//Club parameters
JapaneseConfiguration[Parameter.ClubSpeed] = new UnitConfiguration(
  Parameter.ClubSpeed,
  Unit.MeterPerSecond,
  'm/s',
  'Club Speed',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.AttackAngle] = new UnitConfiguration(
  Parameter.AttackAngle,
  Unit.Degree,
  'Deg',
  'Attack Ang.',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.ClubPath] = new UnitConfiguration(
  Parameter.ClubPath,
  Unit.Degree,
  'Deg',
  'Club Path',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.DynamicLoft] = new UnitConfiguration(
  Parameter.DynamicLoft,
  Unit.Degree,
  'Deg',
  'Dyn. Loft',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.FaceAngle] = new UnitConfiguration(
  Parameter.FaceAngle,
  Unit.Degree,
  'Deg',
  'Face Ang.',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SpinLoft] = new UnitConfiguration(
  Parameter.SpinLoft,
  Unit.Degree,
  'Deg',
  'Spin Loft',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.FaceToPath] = new UnitConfiguration(
  Parameter.FaceToPath,
  Unit.Degree,
  'Deg',
  'Face To Path',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SwingPlane] = new UnitConfiguration(
  Parameter.SwingPlane,
  Unit.Degree,
  'Deg',
  'Swing Pl.',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SwingDirection] = new UnitConfiguration(
  Parameter.SwingDirection,
  Unit.Degree,
  'Deg',
  'Swing Dir.',
  '%.1f',
  Direction.None
);
//Launch parameters
JapaneseConfiguration[Parameter.BallSpeed] = new UnitConfiguration(
  Parameter.BallSpeed,
  Unit.MeterPerSecond,
  'm/s',
  'Ball Speed',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SmashFactor] = new UnitConfiguration(
  Parameter.SmashFactor,
  Unit.UnitLess,
  '',
  'Smash Fac.',
  '%.2f',
  Direction.None
);
JapaneseConfiguration[Parameter.LaunchAngle] = new UnitConfiguration(
  Parameter.LaunchAngle,
  Unit.Degree,
  'Deg',
  'Launch Ang.',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.LaunchDirection] = new UnitConfiguration(
  Parameter.LaunchDirection,
  Unit.Degree,
  'Deg',
  'Launch Dir.',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SpinRate] = new UnitConfiguration(
  Parameter.SpinRate,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.SpinAxis] = new UnitConfiguration(
  Parameter.SpinAxis,
  Unit.Degree,
  'Deg',
  'Spin Axis',
  '%.1f',
  Direction.None
);
//Flight parameters
JapaneseConfiguration[Parameter.Height] = new UnitConfiguration(
  Parameter.Height,
  Unit.Yard,
  'Yds',
  'Height',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.Carry] = new UnitConfiguration(
  Parameter.Carry,
  Unit.Yard,
  'Yds',
  'Carry',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.Total] = new UnitConfiguration(
  Parameter.Total,
  Unit.Yard,
  'Yds',
  'Total',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.Side] = new UnitConfiguration(
  Parameter.Side,
  Unit.Yard,
  'Yds',
  'Side',
  '%.1f',
  Direction.LeftRight
);
JapaneseConfiguration[Parameter.SideTotal] = new UnitConfiguration(
  Parameter.SideTotal,
  Unit.Yard,
  'Yds',
  'Side Tot.',
  '%.1f',
  Direction.LeftRight
);
JapaneseConfiguration[Parameter.LandingAngle] = new UnitConfiguration(
  Parameter.LandingAngle,
  Unit.Degree,
  'Deg',
  'Land. Ang.',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.DistanceToPin] = new UnitConfiguration(
  Parameter.DistanceToPin,
  Unit.Yard,
  'Yds',
  'From Pin',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.DistanceToTarget] = new UnitConfiguration(
  Parameter.DistanceToTarget,
  Unit.Yard,
  'Yds',
  'Target',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.LengthToTarget] = new UnitConfiguration(
  Parameter.LengthToTarget,
  Unit.Yard,
  'Yds',
  'Target',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.HangTime] = new UnitConfiguration(
  Parameter.HangTime,
  Unit.Second,
  's',
  'Hang Time',
  '%.2f',
  Direction.None
);
JapaneseConfiguration[Parameter.LastData] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Yard,
  'Yds',
  'Last Data',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.Score] = new UnitConfiguration(
  Parameter.Score,
  Unit.UnitLess,
  '',
  'Score',
  '%.1f',
  Direction.None
); //TODO change to format "0.#"
JapaneseConfiguration[Parameter.LowPointDistance] = new UnitConfiguration(
  Parameter.LowPointDistance,
  Unit.Inch,
  'In',
  'Low Point',
  '%.0f',
  Direction.BeforeAfter
);

//Skid and roll parameters
//JapaneseConfiguration[Parameter.DistanceScore] = new UnitConfiguration(Parameter.DistanceScore, Unit.UnitLess, "", "DIST. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
//JapaneseConfiguration[Parameter.DirectionScore] = new UnitConfiguration(Parameter.DirectionScore, Unit.UnitLess, "", "DIR. SCORE", "%.0f", Direction.None); //TODO change to format "0.#"
JapaneseConfiguration[Parameter.EffectiveStimp] = new UnitConfiguration(
  Parameter.EffectiveStimp,
  Unit.Foot,
  'Ft',
  'Eff. Stimp',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.SpeedDrop] = new UnitConfiguration(
  Parameter.SpeedDrop,
  Unit.Percentage,
  '%',
  'Speed Drop',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.RollPercentage] = new UnitConfiguration(
  Parameter.RollPercentage,
  Unit.Percentage,
  '%',
  'Roll %',
  '%.0f',
  Direction.None
); // Check the way meter per second squared should be written

/*JapaneseConfiguration[Parameter.RollDeceleration] = new UnitConfiguration(Parameter.RollDeceleration, Unit.MeterPerSecondSquared, "m/s²", "ROLL DEC.", "%.2f", Direction.None);*/ JapaneseConfiguration[
  Parameter.RollSpeed
] = new UnitConfiguration(
  Parameter.RollSpeed,
  Unit.MeterPerSecond,
  'm/s',
  'Roll Speed',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SkidDistance] = new UnitConfiguration(
  Parameter.SkidDistance,
  Unit.Inch,
  'In',
  'Skid Dist.',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.TotalBreak] = new UnitConfiguration(
  Parameter.TotalBreak,
  Unit.Foot,
  'Ft',
  'Total Break',
  '%.0f',
  Direction.LeftRight
); //TODO Foot/Inch format

//Extra units form the Trackman Data Units project
JapaneseConfiguration[Parameter.Dispersion] = new UnitConfiguration(
  Parameter.Dispersion,
  Unit.Yard,
  'Yds',
  'Dispersion',
  '%.1f',
  Direction.None
); //TODO Foot/Inch format
JapaneseConfiguration[Parameter.Temperature] = new UnitConfiguration(
  Parameter.Temperature,
  Unit.Celsius,
  '°C',
  'Temperature',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.Altitude] = new UnitConfiguration(
  Parameter.Altitude,
  Unit.Meter,
  'm',
  'Altitude',
  '%.0f',
  Direction.None
);

//// Base initialization - Extra units from the TPS Units.cs project - Check if this is needed - it has the same title as height and if BeforeAfter is the same as DownUp in the other file
//JapaneseConfiguration[Parameter.TargetHeight] = new UnitConfiguration(Parameter.TargetHeight, Unit.Foot, "ft", "HEIGHT", "%.0f", Direction.BeforeAfter);//Direction.DownUp
//JapaneseConfiguration[Parameter.TargetDistance] = new UnitConfiguration(Parameter.TargetDistance, Unit.Yard, "yds", "DISTANCE", "%.1f", Direction.None);
//JapaneseConfiguration[Parameter.TargetSide] = new UnitConfiguration(Parameter.TargetSide, Unit.Yard, "yds", "SIDE", "%.1f", Direction.LeftRight);
//JapaneseConfiguration[Parameter.TeeHeight] = new UnitConfiguration(Parameter.TeeHeight, Unit.Inch, "in", "HEIGHT", "%.0f", Direction.BeforeAfter);//Direction.DownUp
//JapaneseConfiguration[Parameter.TeeDistance] = new UnitConfiguration(Parameter.TeeDistance, Unit.Foot, "ft", "DISTANCE", "%.0f", Direction.None);//TODO Foot/Inch format

////Override standard values for putting
//JapaneseConfiguration[Parameter.BallSpeed] = new UnitConfiguration(Parameter.BallSpeed, Unit.MeterPerSecond, "mps", "BALL SPEED", "%.1f", Direction.None);
//JapaneseConfiguration[Parameter.LastData] = new UnitConfiguration(Parameter.LastData, Unit.Foot, "ft", "TRACK DIST.", "%.1f", Direction.None);//TODO Foot/Inch format
//JapaneseConfiguration[Parameter.Total] = new UnitConfiguration(Parameter.Total, Unit.Foot, "ft", "DISTANCE", "%.2f", Direction.None);//TODO Foot/Inch format
//JapaneseConfiguration[Parameter.SideTotal] = new UnitConfiguration(Parameter.SideTotal, Unit.Foot, "ft", "SIDE", "%.0f", Direction.None);//TODO Foot/Inch format

//Impact location
JapaneseConfiguration[Parameter.ImpactHeight] = new UnitConfiguration(
  Parameter.ImpactHeight,
  Unit.Millimeter,
  'mm',
  'Imp. Height',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.ImpactOffset] = new UnitConfiguration(
  Parameter.ImpactOffset,
  Unit.Millimeter,
  'mm',
  'Imp. Offset',
  '%.0f',
  Direction.None
);

//Additional parameters added to the TPS
JapaneseConfiguration[Parameter.BackswingTime] = new UnitConfiguration(
  Parameter.BackswingTime,
  Unit.Second,
  's',
  'Backswing',
  '%.2f',
  Direction.None
);
JapaneseConfiguration[Parameter.ForwardswingTime] = new UnitConfiguration(
  Parameter.ForwardswingTime,
  Unit.Second,
  's',
  'Forw. Swing',
  '%.2f',
  Direction.None
);
JapaneseConfiguration[Parameter.Tempo] = new UnitConfiguration(
  Parameter.Tempo,
  Unit.Empty,
  '',
  'Tempo',
  '%.2f',
  Direction.None
);
JapaneseConfiguration[Parameter.DynamicLie] = new UnitConfiguration(
  Parameter.DynamicLie,
  Unit.Degree,
  'Deg',
  'Dyn. Lie',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.StrokeLength] = new UnitConfiguration(
  Parameter.StrokeLength,
  Unit.Inch,
  'In',
  'Stroke Len.',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.Curve] = new UnitConfiguration(
  Parameter.Curve,
  Unit.Yard,
  'Yds',
  'Curve',
  '%.1f',
  Direction.LeftRight
);

//Replacements for putting reports
JapaneseConfiguration[Parameter.Distance] = new UnitConfiguration(
  Parameter.Total,
  Unit.Yard,
  'Yds',
  'Distance',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.TrackedDistance] = new UnitConfiguration(
  Parameter.LastData,
  Unit.Yard,
  'Yds',
  'Track Dist',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SideDistance] = new UnitConfiguration(
  Parameter.Side,
  Unit.Inch,
  'In',
  'Side',
  '%.0f',
  Direction.LeftRight
);
//Add Us UnitSystem
UnitSystemConfiguration[UnitSystem.Japanese] = JapaneseConfiguration;

//Add new parameters to EuropeanConfiguration
EuropeanConfiguration[Parameter.SpinIndex] = new UnitConfiguration(
  Parameter.SpinIndex,
  Unit.Percentage,
  '%',
  'Spin Index',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.SmashIndex] = new UnitConfiguration(
  Parameter.SmashIndex,
  Unit.Percentage,
  '%',
  'Smash Index',
  '%.0f',
  Direction.None
);
EuropeanConfiguration[Parameter.BallSpeedDifference] = new UnitConfiguration(
  Parameter.BallSpeedDifference,
  Unit.MilesPerHour,
  'Mph',
  'Ball Speed Diff',
  '%.1f',
  Direction.None
);
EuropeanConfiguration[Parameter.SpinRateDifference] = new UnitConfiguration(
  Parameter.SpinRateDifference,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate Diff',
  '%.0f',
  Direction.None
);

//Add new parameters to MetricConfiguration
MetricConfiguration[Parameter.SpinIndex] = new UnitConfiguration(
  Parameter.SpinIndex,
  Unit.Percentage,
  '%',
  'Spin Index',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.SmashIndex] = new UnitConfiguration(
  Parameter.SmashIndex,
  Unit.Percentage,
  '%',
  'Smash Index',
  '%.0f',
  Direction.None
);
MetricConfiguration[Parameter.BallSpeedDifference] = new UnitConfiguration(
  Parameter.BallSpeedDifference,
  Unit.MeterPerSecond,
  'm/s',
  'Ball Speed Diff',
  '%.1f',
  Direction.None
);
MetricConfiguration[Parameter.SpinRateDifference] = new UnitConfiguration(
  Parameter.SpinRateDifference,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate Diff',
  '%.0f',
  Direction.None
);

//Add new parameters to UsConfiguration
UsConfiguration[Parameter.SpinIndex] = new UnitConfiguration(
  Parameter.SpinIndex,
  Unit.Percentage,
  '%',
  'Spin Index',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.SmashIndex] = new UnitConfiguration(
  Parameter.SmashIndex,
  Unit.Percentage,
  '%',
  'Smash Index',
  '%.0f',
  Direction.None
);
UsConfiguration[Parameter.BallSpeedDifference] = new UnitConfiguration(
  Parameter.BallSpeedDifference,
  Unit.MilesPerHour,
  'Mph',
  'Ball Speed Diff',
  '%.1f',
  Direction.None
);
UsConfiguration[Parameter.SpinRateDifference] = new UnitConfiguration(
  Parameter.SpinRateDifference,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate Diff',
  '%.0f',
  Direction.None
);

//Add new parameters to KoreanConfiguration
KoreanConfiguration[Parameter.SpinIndex] = new UnitConfiguration(
  Parameter.SpinIndex,
  Unit.Percentage,
  '%',
  'Spin Index',
  '%.0f',
  Direction.None
);
KoreanConfiguration[Parameter.SmashIndex] = new UnitConfiguration(
  Parameter.SmashIndex,
  Unit.Percentage,
  '%',
  'Smash Index',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.BallSpeedDifference] = new UnitConfiguration(
  Parameter.BallSpeedDifference,
  Unit.MilesPerHour,
  'Mph',
  'Ball Speed Diff',
  '%.1f',
  Direction.None
);
KoreanConfiguration[Parameter.SpinRateDifference] = new UnitConfiguration(
  Parameter.SpinRateDifference,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate Diff',
  '%.0f',
  Direction.None
);

//Add new parameters to JapaneseConfiguration
JapaneseConfiguration[Parameter.SpinIndex] = new UnitConfiguration(
  Parameter.SpinIndex,
  Unit.Percentage,
  '%',
  'Spin Index',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.SmashIndex] = new UnitConfiguration(
  Parameter.SmashIndex,
  Unit.Percentage,
  '%',
  'Smash Index',
  '%.0f',
  Direction.None
);
JapaneseConfiguration[Parameter.BallSpeedDifference] = new UnitConfiguration(
  Parameter.BallSpeedDifference,
  Unit.MeterPerSecond,
  'm/s',
  'Ball Speed Diff',
  '%.1f',
  Direction.None
);
JapaneseConfiguration[Parameter.SpinRateDifference] = new UnitConfiguration(
  Parameter.SpinRateDifference,
  Unit.RotationsPerMinute,
  'Rpm',
  'Spin Rate Diff',
  '%.0f',
  Direction.None
);
//}
